<template>
  <el-cascader
    ref="cascader"
    :props="props"
    v-model="value"
    clearable
    size="small"
  ></el-cascader>
</template>

<script>
export default {
  name: "cascader",
  model: {
    prop: "cascaderValue",
    event: "change"
  },
  props: {
    cascaderValue: {
      type: [Array],
      default: () => []
    },
    valueKey: {
      type: String,
      default: "id_Name"
    }
  },
  computed: {
    value: {
      get() {
        return this.cascaderValue;
      },
      set(val) {
        this.$emit("change", val);
      }
    }
  },
  data() {
    return {
      props: {
        lazy: true,
        lazyLoad: async (node, resolve) => {
          const { level } = node;
          let _data = [];
          this.loading = true;
          const { data, message, code } = await this.$request({
            url: "Common -> getListDirectAreaByParentId",
            data: {
              parentId: node.root ? "1" : node.data.id
            }
          });
          _data = data.list || [];
          this.loading = false;
          _data = _data.map((item) => {
            item.id_Name = item.id + "&" + item.areaName;
            return {
              ...item,
              value: item[this.valueKey],
              label: item.areaName,
              leaf: level >= 1
            };
          });
          if (!node.root) {
            _data.unshift({
              value: "",
              label: "全部",
              leaf: true
            });
          }

          if (!_data.length) {
            node.data.leaf = true;
            node.hasChildren = false;
          }
          resolve(_data);
        }
      }
    };
  },
  mounted() {
    this.$refs.cascader.$on("hook:updated", this.updateText);
  },
  beforeDestroy() {
    this.$refs.cascader.$off("hook:updated", this.updateText);
  },
  methods: {
    updateText() {
      if (this.$refs.cascader.presentText) {
        this.$refs.cascader.presentText =
          this.$refs.cascader.presentText.replace(" / 全部", "");
      }
    }
  }
};
</script>

<style></style>
